export default __webpack_public_path__ + "static/media/kitchen3-afterK-480w.38edc9b1.png";